import React, { useEffect, useState } from "react";
import { Translator } from "./translator";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Monitor, Volume2, Smartphone, Users, CalendarDays, Megaphone, Percent, Sparkles } from "lucide-react";


const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";

function getOrCreateDeviceId() {
  let id = localStorage.getItem("teche_device_id");
  if (!id) {
    const rnd =
      window.crypto?.randomUUID?.() ||
      ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        ((c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & 15)) >> (c / 4)).toString(16)
      );
    id = rnd;
    localStorage.setItem("teche_device_id", id);
  }
  return id;
}

const plans = [
  { key: "BASIC", name: "BASIC", price: "8,99€", video: "Qualità molto alta", audio: "supporta circa 135 lingue", gradient: "from-indigo-600 to-indigo-400", devices: 2, newToursText: "Accesso a tutti i nuovi tour del mese (con pubblicità).", oldDiscountText: "Puoi acquistare 2 tour precedenti con sconto del 40%", extendText: "Estendi a 3 amici/familiari: +€5,99 ciascuno", chiccaText: "Senza “Fuori Rotta” speciale",ads: "Meno di quanto potresti pensare"},
  { key: "PLUS",  name: "PLUS",  price: "19,99€", video: "Qualità molto alta", audio: "supporta circa 135 lingue", gradient: "from-sky-600 to-rose-500", devices: 4, ads: "Senza pubblicità", newToursText: "Accesso a tutti i nuovi tour del mese, senza pubblicità.", oldDiscountText: "Puoi acquistare 3 tour precedenti con sconto del 60%", extendText: "Estendi a 4 amici/familiari: +€4,99 ciascuno", chiccaText: "Una “Fuori Rotta” speciale extra a €6,99"}
];


export default function Subscriptions() {
  const { translateText, lang } = Translator();
  const navigate = useNavigate();
  const [loadingKey, setLoadingKey] = useState(null);
  const deviceId = getOrCreateDeviceId();

  // ---- translated UI copy (do NOT call translateText in render) ----
  const [t, setT] = useState({
    title: "Scegli il piano più adatto a te",
    subtitle: "Ogni piano include accesso ai nuovi tour del mese e supporto multi-dispositivo. Estensioni e sconti variano in base al piano.",
    recommended: "Consigliato",
    choose: "Scegli",
    waiting: "Continua",
    learnTitle: "Scopri di più su BASIC e PLUS",
    learnP1: "Ti invitiamo a leggere tutte le informazioni dei piani scelto per conoscere le funzionalità incluse: BASIC e PLUS.",
    learnP2: "La disponibilità del Full HD (1080p), dell’Ultra HD (4K) e dell’HDR dipende dalla tua connessione a Internet e dalle capacità del dispositivo. La maggior parte dei contenuti è disponibile in alta qualità. Consulta i Termini d’uso per maggiori dettagli.",
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const [title, subtitle, recommended, choose, waiting, learnTitle, learnP1, learnP2, learnP3, learnP4] =
          await Promise.all([
            translateText("Scegli il piano più adatto a te"),
            translateText("Consigliato"),
            translateText("Scegli"),
            translateText("Continua"),
            translateText("Scopri di più su BASIC e PLUS"),
            translateText("Ti invitiamo a leggere tutte le informazioni dei piani scelto per conoscere le funzionalità incluse: BASIC e PLUS."),
            translateText("La disponibilità del Full HD (1080p), dell’Ultra HD (4K) e dell’HDR dipende dalla tua connessione a Internet e dalle capacità del dispositivo. La maggior parte dei contenuti è disponibile in alta qualità. Consulta i Termini d’uso per maggiori dettagli."),
          ]);
        if (!cancelled) {
          setT(prev => ({
            ...prev,
            title, subtitle, recommended, choose, waiting,
            learnTitle, learnP1, learnP2, learnP3, learnP4
          }));
        }
      } catch {
        // fail silently, keep Italian defaults
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [lang, translateText]);

  function handleChoose(planKey) {
    navigate("../CompleteRegistration", { state: { planKey } });
  }

  return (
    <div className="min-h-screen bg-neutral-50 py-4">
      <div className="mx-auto max-w-6xl px-4">
        <h1 className="text-3xl md:text-4xl font-bold text-neutral-900 mb-2">
          {t.title}
        </h1>
        <p className="text-neutral-600 mb-8">{t.subtitle}</p>

        {/*<div className="grid gap-6 md:grid-cols-3">*/}
        <div className="grid gap-6 md:grid-cols-2">
          {plans.map((p) => (
            <div
              key={p.key}
              role="button"
              tabIndex={0}
              onClick={() => handleChoose(p.key)}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleChoose(p.key)}
              aria-label={`Scegli piano ${p.name}`}
              className={`relative rounded-2xl border ${
                p.featured ? "border-transparent shadow-xl" : "border-neutral-200"
              } bg-white overflow-hidden cursor-pointer transition hover:shadow-lg hover:-translate-y-0.5`}
            >
              <div className={`h-2 bg-gradient-to-r ${p.gradient}`} />
              {p.key === "PLUS" && (
                <div className="absolute right-3 top-3 text-xs bg-neutral-900 text-white px-2 py-1 rounded-full">
                  {t.recommended}
                </div>
              )}

              <div className="p-6 flex flex-col gap-4">
                <div>
                {/*  <div className="text-sm text-neutral-500">{p.badge}</div>      */}
                  <h2 className="text-2xl font-semibold text-neutral-900">{p.name}</h2>
                </div>

                <div className="text-3xl font-bold">{p.price}</div>
                <ul className="text-sm text-neutral-700 space-y-2">
                  <li className="flex items-center gap-2">
                    <Monitor className="w-4 h-4" /> Video: {p.video}
                  </li>
                  <li className="flex items-center gap-2">
                    <Volume2 className="w-4 h-4" /> Audio: {p.audio}
                  </li>
                  <li className="flex items-start gap-2">
                    <Megaphone className="w-4 h-4 mt-0.5" /> Pubblicità: {p.ads}
                  </li>
                  <li className="flex items-center gap-2">
                    <CalendarDays className="w-4 h-4" /> {p.newToursText}
                  </li>
                  <li className="flex items-center gap-2">
                    <Percent className="w-4 h-4" /> {p.oldDiscountText}
                  </li>
                  <li className="flex items-center gap-2">
                    <Users className="w-4 h-4" /> {p.extendText}
                  </li>
                  <li className="flex items-center gap-2">
                    <Sparkles className="w-4 h-4" /> {p.chiccaText}
                  </li>
                  {/* keep these if you still want to show device/video/audio details */}
             {/*      <li className="flex items-center gap-2">
                    <Smartphone className="w-4 h-4" /> {p.devices} dispositivi per utente
                  </li>   */}
                </ul>


                <button
                  onClick={() => handleChoose(p.key)}
                  disabled={loadingKey === p.key}
                  className={`mt-2 inline-flex items-center justify-center rounded-xl px-4 py-2 text-white bg-[#324B8E] hover:opacity-95 focus:ring-2 focus:ring-offset-2 focus:ring-neutral-900 disabled:opacity-60`}
                >
                  {loadingKey === p.key ? t.waiting : t.choose}
                </button>

{/*                <div className="text-xs text-neutral-500 mt-2">
                  Sito web e app Te.C.H-e. Accesso consentito solo con account Te.C.H-e, fino a {p.devices} dispositivi.
                </div>
*/}              </div>
            </div>
          ))}
        </div>

        {/* Learn more / legal notes */}
        <div className="mt-8 text-sm text-neutral-700 space-y-2">
          <h4 className="font-semibold">{t.learnTitle}</h4>
          <p>{t.learnP1}</p>
          <p>{t.learnP2}</p>
          <p>{t.learnP3}</p>
          <p>{t.learnP4}</p>
        </div>
      </div>
    </div>
  );
}

function ShareInvite({ placeholder, sendLabel, sendingLabel }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  async function sendInvite() {
    if (!email) return;
    try {
      setBusy(true);
      await axios.post(
        `${BASE}/share/send`,
        { friendEmail: email },
        { withCredentials: true }
      );
      alert("Invito inviato. L’amico deve confermare dall’app o dal sito.");
      setEmail("");
    } catch (e) {
      alert(e?.response?.data?.error || "Impossibile inviare l’invito");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <input
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="email"
        placeholder={placeholder}
        className="flex-1 rounded-xl border border-neutral-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-neutral-900"
      />
      <button
        onClick={sendInvite}
        disabled={busy}
        className="rounded-xl px-4 py-2 bg-neutral-900 text-white hover:bg-neutral-800 disabled:opacity-60"
      >
        {busy ? sendingLabel : sendLabel}
      </button>
    </div>
  );
}
